import { createFeatureSelector, createSelector } from '@ngrx/store';
import { directorAdapter, DirectorState } from './director.reducer';

export const getDirectorState =
  createFeatureSelector<DirectorState>('directors');

export const {
  selectAll: getAllDirectors,
  selectEntities: getDirectorEntities,
  selectIds: getDirectorIds,
  selectTotal: getTotalDirectors,
} = directorAdapter.getSelectors(getDirectorState);

export const getFirstEightDirectorships = createSelector(
  getAllDirectors,
  directors => directors.slice(0, 8)
);

export const getBodyListOfDirectorships = createSelector(
  getAllDirectors,
  directors => directors.slice(8)
);
export const getCurrentPage = createSelector(
  getDirectorState,
  (state: DirectorState) => state.currentPage
);

export const getTotalPages = createSelector(
  getDirectorState,
  (state: DirectorState) => state.totalPages
);

export const getTotalItems = createSelector(
  getDirectorState,
  (state: DirectorState) => state.totalItems
);

export const getLoading = createSelector(
  getDirectorState,
  (state: DirectorState) => state.loading
);

export const getBiggestInfluencers = createSelector(
  getDirectorState,
  state => state.biggestInfluencers
);

export const getSelectedDirector = createSelector(
  getDirectorState,
  (state: DirectorState) => state.selectedDirector
);
export const getSelectedDirectors = createSelector(
  getDirectorState,
  (state: DirectorState) => state.selectedDirectors
);

export const selectAllDirectors = getAllDirectors;
